/**
 * Created by adam.clarke on 24/10/2016.
 */

admin.registerLoad(function (prefix) {

    // setup reports preview field

    $(prefix + ".js-report-preview").each(function () {

        var url = $(this).data('url');
        var target = $($(this).data('target'));
        var $this = $(this);

        run_preview();

        find_filters().change(function () {
            run_preview();
        });

        function run_preview() {
            // need a preview report function
            var data = find_filters().serialize();
            var full_url = url + "?" + data;

            target.html("Updating...");
            $this.html("");

            $('#report_count_field').val("-");

            $.ajax({
                url: full_url
            }).done(function(response) {
                if (response.data.count > 0) {
                    target.html("Found <strong>" + response.data.count + "</strong> rows. Showing first " + Math.min(25, response.data.count) + " rows...");
                    $this.html(response.data.html);

                    $('#report_count_field').val(response.data.count);
                } else {
                    target.html("No data found");
                }
                //target.append("<br /><a href='" + full_url + "&html=1' target='_blank'>" + decodeURI(data) + "</a>"); // debug url for preview
            }).error(function() {
                target.append("Error fetching <a href='" + full_url + "&html=1' target='_blank'>" + decodeURI(data) + "</a>");
            });
        }

        function find_filters() {
            return $('.admin-field-admin-filters').find("[name^='filter']");
        }
    });

    /**
     * When adding a field in the popup to a report, do some logic as to what can be selected there, and
     * only allow field to be selected for default type, and if a field is selected change type to default
     * and fill in the name
     */
    $(prefix + '.inline-edit-reports-fields .identifier_field select').off("change.reports");
    $(prefix + '.inline-edit-reports-fields .identifier_field select').on("change.reports", function () {
        var val = $(this).val();
        if (val == "") return;

        var option = $(this).find("option[value='" + val + "']").text();
        if (option.indexOf("(") > 0)
        {
            option = option.substr(0, option.indexOf("(")-1);
        }
        $('.inline-edit-reports-fields .identifier_name input').val(option);

        // change type to default as we have a field
        if ($(prefix + '.inline-edit-reports-fields .identifier_type select').val() != "1") {
            $(prefix + '.inline-edit-reports-fields .identifier_type select').val("1");
            $(prefix + '.inline-edit-reports-fields .identifier_type select').trigger("chosen:updated");
            $(prefix + '.inline-edit-reports-fields .identifier_type select').trigger("change");
        }
    });

    $(prefix + '.inline-edit-reports-fields .identifier_type select').off("change.reports");
    $(prefix + '.inline-edit-reports-fields .identifier_type select').on("change.reports", function () {
        var val = $(this).val();
        if (val != "1")
        {
            // remove field as they arent needed for anything other than default type
            $(prefix + '.inline-edit-reports-fields .identifier_field select').val("");
            $(prefix + '.inline-edit-reports-fields .identifier_field select').trigger("chosen:updated");
        }
    });

    $(prefix + '.js-report-batch-add').off("click");
    $(prefix + '.js-report-batch-add').on("click", function (ev) {
        ev.preventDefault();

        var $this = $(this);

        var url = $this.attr("href");

        $('#report-batch-add-modal').html($('#modal-wait-template').html());

        $('#report-batch-add-modal').modal();
        $('#report-batch-add-modal .modal-content').unbind("load");
        $('#report-batch-add-modal .modal-content').load(url, function (ev) {

            // when modal content has loaded, setup save click event
            $('#report-batch-add-modal .js-report-batch-save').off("click");
            $('#report-batch-add-modal .js-report-batch-save').on("click", function (ev) {
                ev.preventDefault();

                // need to submit the modals main form via ajax and then reload the report list in the panel
                $(this).closest("form").submit();
                $('#report-batch-add-modal').modal("hide");
                $this.closest(".js-inline-list").trigger("inline.show_wait");
            });

            // when form has done submitting, reload the list
            $('#report-batch-add-iframe').unbind("load");
            $('#report-batch-add-iframe').load(function () {
                $this.closest(".js-inline-list").trigger("inline.reload");
            });

        });

    });

});